var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.realSignGroup.name || ""))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.realSignGroup.realComName || ""))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.merchantTypeMap[_vm.realSignGroup.merchantType])
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [_vm._v(_vm._s(_vm.realSignGroup.memo || ""))])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "realComList",
          staticClass: "multipleTable",
          staticStyle: { width: "100%", "font-size": "12px" },
          attrs: { data: _vm.realSignComList, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "realComName", label: "适用公司名称" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "realComInfo.code", label: "公司代码", width: "100" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "realComInfo.socialCreditCode",
              label: "统一社会信用代码",
              width: "200"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "realComInfo.taxPayType",
              label: "纳税类型",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.realComInfo.taxPayType == 0
                      ? _c("span", [_vm._v("无")])
                      : _vm._e(),
                    _vm._v(" "),
                    rows.row.realComInfo.taxPayType == 1
                      ? _c("span", [_vm._v("小规模纳税人")])
                      : _vm._e(),
                    _vm._v(" "),
                    rows.row.realComInfo.taxPayType == 2
                      ? _c("span", [_vm._v("一般纳税人")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "realComInfo.taxFree",
              label: "是否抵扣税",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.realComInfo.taxFree == 0
                      ? _c("span", [_vm._v("根据业务确定")])
                      : _vm._e(),
                    _vm._v(" "),
                    rows.row.realComInfo.taxFree == 1
                      ? _c("span", [_vm._v("抵扣税")])
                      : _vm._e(),
                    _vm._v(" "),
                    rows.row.realComInfo.taxFree == 2
                      ? _c("span", [_vm._v("不抵扣税")])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "realComInfo.contactName",
              label: "联系人",
              width: "120"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "realComInfo.contactTel",
              label: "联系电话",
              width: "160"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("适用范围名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("签约主体")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("适用范围")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("描述")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("适用公司信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43d11632", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43d11632","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/realCom/RealSignDetail.vue
// module id = 2614
// module chunks = 0